/**
 * ConfidenceBadge - Visual indicator for alignment confidence score
 * 
 * Displays confidence score with color-coded background:
 * - Green: >0.9 (excellent)
 * - Yellow: >0.7 (good)
 * - Red: <0.7 (needs manual adjustment)
 */

import React from 'react'
import './ConfidenceBadge.css'

interface ConfidenceBadgeProps {
  score: number
}

export const ConfidenceBadge: React.FC<ConfidenceBadgeProps> = ({ score }) => {
  const percentage = Math.round(score * 100)
  
  const getScoreClass = () => {
    if (score > 0.9) return 'score-excellent'
    if (score > 0.7) return 'score-good'
    return 'score-poor'
  }

  const getScoreLabel = () => {
    if (score > 0.9) return 'Excellent'
    if (score > 0.7) return 'Good'
    return 'Needs Adjustment'
  }

  return (
    <div className={`confidence-badge ${getScoreClass()}`}>
      <div className="score-value">{percentage}%</div>
      <div className="score-label">{getScoreLabel()}</div>
    </div>
  )
}
